import i18n from "@/i18n";
// CALENDAR-ABSENCES-V1 — manager absence workflow shared by Schedule and Review Hours.
import { useCallback, useMemo, useState } from "react";
import { Button } from "@/components/ui/button";
import AbsenceEditorDialog from "./AbsenceEditorDialog";
import VuosilomaEvidenceDialog from "./VuosilomaEvidenceDialog";
import { canManageAbsences } from "./absenceShared";

function shiftDatesFrom(employees) {
    const out = {};
    for (const row of employees || []) {
        const set = new Set();
        for (const c of row.cells || []) {
            if ((c.shifts || []).length > 0 || (c.shift_ids || []).length > 0) set.add(c.date);
        }
        out[row.employee_id] = set;
    }
    return out;
}

export function useAbsenceActions({ user, restaurantId, employees, locked, onChanged, view }) {
    const canManage = canManageAbsences(user);
    const [target, setTarget] = useState(null);
    const [evidence, setEvidence] = useState(null);
    const shiftDatesByEmployee = useMemo(() => shiftDatesFrom(employees), [employees]);

    const open = useCallback((t) => setTarget({ ...t, key: `${t.mode}-${Date.now()}` }), []);
    const saved = useCallback(() => { setTarget(null); onChanged?.(); }, [onChanged]);

    const toolbar = canManage ? (
        <Button variant="outline" size="sm" data-testid={`workforce-${view}-add-absence`}
            onClick={() => open({ mode: "add" })} disabled={!employees || !employees.length}>
            {locked ? i18n.t("wf.useAbsenceActions.absencesLocked", "Absences (locked)") : i18n.t("wf.useAbsenceActions.addAbsence", "Add absence")}
        </Button>
    ) : null;

    const dialogs = (
        <>
            {target && (
                <AbsenceEditorDialog key={target.key} target={target} restaurantId={restaurantId}
                    employees={employees} shiftDatesByEmployee={shiftDatesByEmployee}
                    locked={locked} onClose={() => setTarget(null)} onSaved={saved}
                    onOpenEvidence={(absence, kind) => {
                        setTarget(null);
                        setEvidence({ absence, kind });
                    }} />
            )}
            {evidence && (
                <VuosilomaEvidenceDialog open onOpenChange={(v) => !v && setEvidence(null)}
                    employeeId={evidence.absence.employee_id} restaurantId={restaurantId}
                    initialKind={evidence.kind} initialAbsenceId={evidence.absence.absence_id}
                    onSaved={() => setEvidence(null)} />
            )}
        </>
    );

    return { onAbsenceOpen: canManage ? open : undefined, toolbar, dialogs };
}
